import { gql } from '__generated__';

export const InvitationFieldsFragment = gql(`
  fragment InvitationFields on Invitation {
    id
    active
    prefix
    start_date
    end_date
    has_unique_codes
    max_uses
    uses
    ignore_capacity
    download_url
    available
    description
    confirmation_mail_text
    code {
      id
      registration_url
    }
    example {
      id
      value
    }
    tickets {
      id
      title
    }
    promotions {
      id
    }
    participant_fields {
      id
    }
    time_slots {
      id
      start_date
      start_time
      title
      multi_date
    }
    team {
      id
      title
      team_type {
        id
      }
    }
    translations {
      ...TranslationFields
    }
  }
`);

export default gql(`
  query GetInvitation($event_id: ID!, $invitation_id: ID!) {
    invitation(id: $invitation_id) {
      ...InvitationFields
    }
    event(id: $event_id) {
      id
      title
      logo {
        id
        url
      }
      brand_color
      locale
      tickets {
        id
        title
        active
        preregistration
        promotions {
          id
          title
          active
        }
        time_slots {
          id
          title
          start_date
          start_time
          multi_date
          active
        }
      }
      participant_fields {
        id
        enabled
        title
        required_promotions {
          id
        }
      }
    }
  }
`);
